<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Nouveau Produit</h4>
            <h6>Créer un nouveau Produit</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <div class="page-btn">
              <router-link to="/produits/" class="btn btn-secondary"
                ><vue-feather type="arrow-left" class="me-2"></vue-feather
                >Retourner vers les Produits</router-link
              >
            </div>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
      </div>
      <!-- /add -->
      <form @submit.prevent="submitForm">
        <div class="card">
          <div class="card-body add-product pb-0">
            <div class="accordion-card-one accordion" id="accordionExample">
              <div class="accordion-item">
                <div class="accordion-header" id="headingOne">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-controls="collapseOne"
                  >
                    <div class="addproduct-icon">
                      <h5>
                        <vue-feather type="info" class="add-info"></vue-feather
                        ><span>Informations du Produit</span>
                      </h5>
                      <a href="javascript:void(0);"
                        ><vue-feather
                          type="chevron-down"
                          class="chevron-down-add"
                        ></vue-feather
                      ></a>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <div class="row">
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="input-blocks add-product list">
                          <label>Référence</label>
                          <input
                            type="text"
                            class="form-control list"
                            v-model="form.referance_produit"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Nom de Produit</label>
                          <input
                            v-model="form.nom"
                            type="text"
                            class="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Catégorie</label>
                          <select
                            class="form-select"
                            v-model="form.categorie_produit_id"
                          >
                            <option value="">Choisir</option>
                            <option
                              v-for="cat in categoryOptions"
                              :key="cat.id"
                              :value="cat.id"
                            >
                              {{ cat.nom }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Dimension</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="form.dimensions"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Surface</label>
                          <input
                            type="Number"
                            min="0"
                            step="0.01"
                            class="form-control"
                            v-model="form.surface"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Volume</label>
                          <input
                            type="Number"
                            min="0"
                            step="0.01"
                            class="form-control"
                            v-model="form.volume"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div class="add-product-new">
                      <div class="row">
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="input-blocks add-product list">
                            <label>Poids</label>
                            <input
                              type="Number"
                              min="0"
                              step="0.01"
                              class="form-control list"
                              placeholder="Enter SKU"
                              v-model="form.poids"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label">Entrepot</label>
                            <select
                              class="form-control"
                              v-model="form.entrepot_par_defaut"
                              required
                            >
                              <option value="">Choisir un entrepôt</option>
                              <option
                                v-for="warehouse in warehouseOptions"
                                :key="warehouse.id"
                                :value="warehouse.id"
                              >
                                {{ warehouse.nom }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label">Statut d'achat</label>
                            <div class="d-flex gap-3 mt-2">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_achat"
                                  id="achat_actif"
                                  :value="true"
                                  v-model="form.statut_achat"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="achat_actif"
                                >
                                  Actif
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_achat"
                                  id="achat_inactif"
                                  :value="false"
                                  v-model="form.statut_achat"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="achat_inactif"
                                >
                                  Inactif
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label">Statut de Vente</label>
                            <div class="d-flex gap-3 mt-2">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_vente"
                                  id="vente_actif"
                                  :value="true"
                                  v-model="form.statut_vente"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="vente_actif"
                                >
                                  Actif
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_vente"
                                  id="vente_inactif"
                                  :value="false"
                                  v-model="form.statut_vente"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="vente_inactif"
                                >
                                  Inactif
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Editor -->
                    <div class="col-lg-12">
                      <div
                        class="input-blocks summer-description-box transfer mb-3"
                      >
                        <label>Description</label>
                        <textarea
                          v-model="form.description"
                          class="form-control h-100"
                          rows="5"
                          required
                        ></textarea>
                        <p class="mt-1">Maximum 60 Characters</p>
                      </div>
                    </div>
                    <!-- /Editor -->
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-card-one accordion" id="accordionExample2">
              <div class="accordion-item">
                <div class="accordion-header" id="headingTwo">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-controls="collapseTwo"
                  >
                    <div class="text-editor add-list">
                      <div class="addproduct-icon list icon">
                        <h5>
                          <vue-feather
                            type="life-buoy"
                            class="add-info"
                          ></vue-feather
                          ><span>Prix & Stock</span>
                        </h5>
                        <a href="javascript:void(0);"
                          ><vue-feather
                            type="chevron-down"
                            class="chevron-down-add"
                          ></vue-feather
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample2"
                >
                  <div class="accordion-body">
                    <div class="tab-content" id="pills-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div class="row">
                          <div class="col-lg-4 col-sm-6 col-12">
                          <div class="input-blocks add-product">
                              <div class="d-flex align-items-center justify-content-between gap-2">
                                <label class="mb-0">Prix d'achat</label>
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                  :disabled="priceSearchLoading"
                                  @click="searchMarketPrice"
                                >
                                  {{ priceSearchLoading ? "Recherche..." : "Comparer Maroc" }}
                                </button>
                              </div>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.prix_achat"
                                required
                              />
                              <div v-if="priceSearchError" class="text-danger small mt-2">
                                {{ priceSearchError }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Prix de Vente</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.prix_vente"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Prix de Vente Minimum</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.prix_vente_minimum"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div v-if="priceSearchResult" class="row">
                          <div class="col-12">
                            <div class="border rounded p-3 mb-3 bg-light">
                              <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                                <div>
                                  <h6 class="mb-1">Prix trouvés au Maroc</h6>
                                  <div class="small text-muted">
                                    Référence recherchée: {{ priceSearchResult.query || form.referance_produit }}
                                  </div>
                                </div>
                                <span v-if="priceSearchBest && priceSearchBest.price" class="badge bg-primary">
                                  Plus proche: {{ formatMoney(priceSearchBest.price) }}
                                </span>
                              </div>
                              <div v-if="!priceSearchResult.configured" class="alert alert-warning py-2 mb-0">
                                {{ priceSearchResult.message }}
                              </div>
                              <div v-else-if="!priceSearchRows.length" class="text-muted small">
                                Aucun prix exploitable trouvé. Essayez avec une référence plus précise.
                              </div>
                              <div v-else class="table-responsive">
                                <table class="table table-sm align-middle mb-0">
                                  <thead>
                                    <tr>
                                      <th>Source</th>
                                      <th>Prix</th>
                                      <th>Écart</th>
                                      <th>Lien</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(result, index) in priceSearchRows" :key="`${result.url}-${index}`">
                                      <td>
                                        <div class="fw-semibold">{{ result.title }}</div>
                                        <div class="small text-muted">{{ result.display_link }}</div>
                                      </td>
                                      <td>{{ result.price ? formatMoney(result.price) : "—" }}</td>
                                      <td>
                                        <span v-if="result.difference !== null && result.difference !== undefined">
                                          {{ formatSignedMoney(result.difference) }}
                                          <span class="text-muted">({{ result.difference_percent }}%)</span>
                                        </span>
                                        <span v-else>—</span>
                                      </td>
                                      <td>
                                        <a :href="result.url" target="_blank" rel="noopener noreferrer">
                                          Voir
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Taux TVA</label>
                              <input
                                type="number"
                                step="0.01"
                                min="0"
                                value="20"
                                class="form-control"
                                v-model="form.taux_tva"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Stock Optimal</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                placeholder="Choose"
                                v-model="form.stock_optimal"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Stock initial</label>
                              <input
                                type="number"
                                min="0"
                                step="1"
                                class="form-control"
                                v-model.number="form.initial_stock"
                              />
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Seuil d'alerte de rupture de stock</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.seuil_alerte_stock"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          class="accordion-card-one accordion"
                          id="accordionExample3"
                        >
                          <div class="accordion-item">
                            <div class="accordion-header" id="headingThree">
                              <div
                                class="accordion-button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseThree"
                                aria-controls="collapseThree"
                              >
                                <div class="addproduct-icon list">
                                  <h5>
                                    <vue-feather
                                      type="image"
                                      class="add-info"
                                    ></vue-feather
                                    ><span>Image</span>
                                  </h5>
                                  <a href="javascript:void(0);"
                                    ><vue-feather
                                      type="chevron-down"
                                      class="chevron-down-add"
                                    ></vue-feather
                                  ></a>
                                </div>
                              </div>
                            </div>
                            <div
                              id="collapseThree"
                              class="accordion-collapse collapse show"
                              aria-labelledby="headingThree"
                              data-bs-parent="#accordionExample3"
                            >
                              <div class="accordion-body">
                                <div class="text-editor add-list add">
                                  <div class="col-lg-12">
                                    <div class="add-choosen">
                                      <div class="input-blocks">
                                        <div class="image-upload">
                                          <input
                                            type="file"
                                            accept="image/*"
                                            multiple
                                            ref="imageInput"
                                            @change="handleImageUpload"
                                          />
                                          <div class="image-uploads">
                                            <i
                                              data-feather="plus-circle"
                                              class="plus-down-add me-0"
                                            ></i>
                                            <h4>Ajouter des Images</h4>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="phone-img"
                                        v-for="(preview, index) in imagePreviews"
                                        :key="preview.id"
                                      >
                                        <img
                                          :src="preview.url"
                                          alt="Preview"
                                          style="
                                            max-width: 100%;
                                            max-height: 100%;
                                            object-fit: contain;
                                            display: block;
                                          "
                                        />

                                        <a
                                          href="javascript:void(0);"
                                          @click.prevent="removeImage(index)"
                                          ><vue-feather
                                            type="x"
                                            class="x-square-add remove-product"
                                          ></vue-feather
                                        ></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="btn-addproduct mb-4">
            <button type="button" class="btn btn-cancel me-2">Annuler</button>
            <button type="submit" class="btn btn-submit">
              Ajouter un Produit
            </button>
          </div>
        </div>
      </form>
      <!-- /add -->
    </div>
  </div>
  <add-product-modal></add-product-modal>
</template>

<script>
import Swal from "sweetalert2";
import {
  getWarehouseData,
  createProduct,
  searchProductMarketPrice,
} from "@/services/productsService";
import { getCurrentUser } from "@/services/authService";
import { fetchProductCategories } from "@/services/productCategoryService";
import { toast } from "vue3-toastify";
const user = getCurrentUser();
export default {
  data() {
    return {
      form: {
        societe_id: null,
        entrepot_par_defaut: "",
        description: "",
        dimensions: "",
        prix_vente_minimum: "",
        nom: "",
        stock_optimal: null,
        initial_stock: 0,
        image_produit: "",
        statut_achat: true, // Set default value (true = Actif)
        referance_produit: "",
        prix_achat: "",
        prix_vente: "",
        statut_vente: true, // Set default value (true = Actif)
        seuil_alerte_stock: null,
        surface: "",
        taux_tva: 20, // Set default value
        volume: "",
        poids: "",
        categorie_produit: "",
        categorie_produit_id: "",
      },
      categoryOptions: [],
      salesStatus: [
        { id: true, nom: "Actif" },
        { id: false, nom: "Inactif" },
      ],
      selectedImages: [],
      imagePreviews: [],
      warehouseOptions: [],
      priceSearchLoading: false,
      priceSearchResult: null,
      priceSearchError: "",
    };
  },
  computed: {
    priceSearchBest() {
      return this.priceSearchResult ? this.priceSearchResult.best_match : null;
    },
    priceSearchRows() {
      return this.priceSearchResult && Array.isArray(this.priceSearchResult.results)
        ? this.priceSearchResult.results.slice(0, 5)
        : [];
    },
  },
  methods: {
    createPreviewEntry(file) {
      return {
        id: `${file.name}-${file.lastModified}-${Math.random().toString(36).slice(2)}`,
        url: URL.createObjectURL(file),
      };
    },
    revokePreview(preview) {
      if (preview && preview.url) {
        URL.revokeObjectURL(preview.url);
      }
    },
    // Extract a human-friendly error message from Axios/Laravel responses
    getErrorMessage(error) {
      const data = error && error.response && error.response.data;
      if (!data) {
        return error && error.message ? error.message : "Une erreur est survenue.";
      }
      if (typeof data === "string") {
        return data;
      }
      if (data.error) {
        return data.error;
      }
      // Laravel validation errors: { message, errors: { field: [msg] } }
      if (data.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        const firstVal = data.errors[firstKey];
        if (Array.isArray(firstVal) && firstVal.length) {
          return firstVal[0];
        }
        if (typeof firstVal === "string") {
          return firstVal;
        }
      }
      if (data.message) {
        return data.message;
      }
      return "Une erreur est survenue.";
    },
    async loadCategories() {
      try {
        const data = await fetchProductCategories();
        this.categoryOptions = (data || []).map((cat) => ({
          id: cat.id,
          nom: cat.nom,
        }));
      } catch (error) {
        console.error(error);
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Impossible de charger les catégories."
        );
      }
    },
    getCategoryNameById(id) {
      const match = this.categoryOptions.find((c) => String(c.id) === String(id));
      return match ? match.nom : "";
    },
    formatMoney(value) {
      const amount = Number(value);
      if (!Number.isFinite(amount)) {
        return "—";
      }
      return `${amount.toFixed(2)} MAD`;
    },
    formatSignedMoney(value) {
      const amount = Number(value);
      if (!Number.isFinite(amount)) {
        return "—";
      }
      const sign = amount > 0 ? "+" : "";
      return `${sign}${amount.toFixed(2)} MAD`;
    },
    async searchMarketPrice() {
      this.priceSearchError = "";
      this.priceSearchResult = null;

      if (!this.form.referance_produit) {
        this.priceSearchError = "Ajoutez la référence du produit avant la recherche.";
        return;
      }

      if (this.form.prix_achat === "" || Number(this.form.prix_achat) < 0) {
        this.priceSearchError = "Ajoutez un prix d'achat valide avant la recherche.";
        return;
      }

      this.priceSearchLoading = true;
      try {
        this.priceSearchResult = await searchProductMarketPrice({
          referance_produit: this.form.referance_produit,
          nom: this.form.nom,
          prix_achat: Number(this.form.prix_achat),
        });

        if (this.priceSearchResult?.message) {
          toast.info(this.priceSearchResult.message);
        }
      } catch (error) {
        console.error(error);
        this.priceSearchError = this.getErrorMessage(error);
        toast.error(this.priceSearchError);
      } finally {
        this.priceSearchLoading = false;
      }
    },
    handleImageUpload(event) {
      const input = event.target;
      const files = input && input.files ? Array.from(input.files) : [];
      if (!files.length) {
        if (input) {
          input.value = "";
        }
        return;
      }

      files.forEach((file) => {
        const alreadySelected = this.selectedImages.some(
          (existing) =>
            existing.name === file.name &&
            existing.size === file.size &&
            existing.lastModified === file.lastModified
        );
        if (alreadySelected) {
          return;
        }
        this.selectedImages.push(file);
        this.imagePreviews.push(this.createPreviewEntry(file));
      });

      if (input) {
        input.value = "";
      }
    },
    removeImage(index) {
      const preview = this.imagePreviews[index];
      this.revokePreview(preview);
      this.imagePreviews.splice(index, 1);
      this.selectedImages.splice(index, 1);
      if (!this.selectedImages.length) {
        this.form.image_produit = "";
        if (this.$refs.imageInput) {
          this.$refs.imageInput.value = "";
        }
      }
    },
    clearSelectedImages() {
      this.imagePreviews.forEach((preview) => this.revokePreview(preview));
      this.imagePreviews = [];
      this.selectedImages = [];
      this.form.image_produit = "";
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = "";
      }
    },
    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },

    async getWarehouseData() {
      try {
        const data = await getWarehouseData();

        // Ensure data structure is correct
        if (Array.isArray(data)) {
          this.warehouseOptions = data;
        } else if (data && Array.isArray(data.data)) {
          // Handle if API returns { data: [...] }
          this.warehouseOptions = data.data;
        } else if (data && Array.isArray(data.warehouses)) {
          // Handle if API returns { warehouses: [...] }
          this.warehouseOptions = data.warehouses;
        } else {
          console.warn("Unexpected data structure:", data);
          this.warehouseOptions = [];
        }
      } catch (error) {
        console.error("Error loading warehouses:", error);
        this.warehouseOptions = [];
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Impossible de charger les entrepôts.",
          confirmButtonClass: "btn btn-danger",
        });
        toast.error(this.getErrorMessage(error));
      }
    },

    async submitForm() {
      try {
        this.form.societe_id = user.societe_id;
        if (!this.form.categorie_produit_id) {
          toast.error("Choisissez une catégorie de produit.");
          return;
        }
        const selectedCategoryName = this.getCategoryNameById(
          this.form.categorie_produit_id
        );
        this.form.categorie_produit = selectedCategoryName || this.form.categorie_produit;
        this.form.image_produit = this.selectedImages.length
          ? this.selectedImages[0].name
          : "";

        const formData = new FormData();
        formData.append("societe_id", user.societe_id);
        formData.append("nom", this.form.nom);
        formData.append("description", this.form.description);
        formData.append("dimensions", this.form.dimensions);
        formData.append("prix_vente_minimum", this.form.prix_vente_minimum);
        formData.append("stock_optimal", this.form.stock_optimal);
        if (
          this.form.initial_stock !== null &&
          this.form.initial_stock !== ""
        ) {
          formData.append("initial_stock", this.form.initial_stock);
        }
        formData.append("surface", this.form.surface);
        formData.append("volume", this.form.volume);
        formData.append("poids", this.form.poids);
        formData.append("prix_achat", this.form.prix_achat);
        formData.append("prix_vente", this.form.prix_vente);
        formData.append("referance_produit", this.form.referance_produit);
        formData.append("seuil_alerte_stock", this.form.seuil_alerte_stock);
        formData.append("taux_tva", this.form.taux_tva);
        formData.append("categorie_produit_id", this.form.categorie_produit_id);
        if (this.form.categorie_produit) {
          formData.append("categorie_produit", this.form.categorie_produit);
        }
        if (
          this.form.entrepot_par_defaut !== "" &&
          this.form.entrepot_par_defaut !== null
        ) {
          formData.append("entrepot_par_defaut", this.form.entrepot_par_defaut);
        }
        formData.append("statut_achat", this.form.statut_achat ? 1 : 0);
        formData.append("statut_vente", this.form.statut_vente ? 1 : 0);

        if (this.selectedImages.length) {
          this.selectedImages.forEach((file, index) => {
            if (index === 0) {
              formData.append("image_produit", file);
            } else {
              formData.append("images[]", file);
            }
          });
        }

        const response = await createProduct(formData);
        const createdProduct =
          response && response.data ? response.data : response;

        // Update localStorage if it exists
        if (localStorage.getItem("products") != null) {
          let products = JSON.parse(localStorage.getItem("products"));
          products.push(createdProduct);
          localStorage.setItem("products", JSON.stringify(products));
        }

        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Produit créé avec succès.",
          confirmButtonClass: "btn btn-success",
        }).then(() => {
          this.clearSelectedImages();
          // Optionally redirect or reset form
          this.$router.push("/produits/");
        });
      } catch (error) {
        console.error("Error creating product:", error);
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: this.getErrorMessage(error) || "Erreur lors de la création du produit.",
          confirmButtonClass: "btn btn-danger",
        });
        toast.error(this.getErrorMessage(error));
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },

    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;
      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
  },

  mounted() {
    this.loadCategories();
    this.getWarehouseData();
  },
  beforeUnmount() {
    this.clearSelectedImages();
  },
};
</script>
